import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader } = FiIcons;

export default function Step3Loading({ onComplete }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 3000); // Simulate 3-second processing delay
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div 
      initial={{ opacity: 0 }} animate={{ opacity: 1 }}
      className="card-premium flex flex-col items-center justify-center py-20"
    >
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
        className="mb-8 text-blue-600"
      >
        <SafeIcon icon={FiLoader} className="w-16 h-16" />
      </motion.div>
      
      <h2 className="text-2xl font-bold text-slate-900 mb-2">Searching for the best offers...</h2>
      <p className="text-slate-500">Securely communicating with carriers and lenders.</p>
    </motion.div>
  );
}